import {
  atom,
  selector
} from 'recoil';

export const activeProductDefault = atom({
  key: 'ActiveProductDefault',
  default: null
});

export const activeProductState = selector({
  key: 'activeProductState',
  get: async ({ get }) => get(activeProductDefault),
  set: ({ _, set }, activeProduct) => {
    set(activeProductDefault, {
      activeProduct
    });
  }
});